import TeamInfoConstants from '../constants/TeamInfo.constants';
import { TeamInfoPayload } from '../types/TeamInfo.types';
import * as PiIntegrationsAPI from '../api/PiIntegrations.api';
import { AxiosResponse } from 'axios';

/**
 * Fetch team information based on members' behavioral assessment data
 * @param payload TeamInfoPayload containing members' data
 * @param workspaceSlug Slug of the workspace for which to fetch team info
 */
export const fetchTeamInfo = (payload: TeamInfoPayload, workspaceSlug: string) => {
  return dispatch => {
    dispatch({ type: TeamInfoConstants.Actions.FETCH_TEAM_INFO_REQUEST });

    return PiIntegrationsAPI.getTeamInfo(payload)
      .then((response: AxiosResponse) => {
        dispatch({
          type: TeamInfoConstants.Actions.FETCH_TEAM_INFO_SUCCESS,
          payload: {
            ...response.data,
            workspaceSlug,
          },
        });
        return response;
      })
      .catch(error => {
        dispatch({
          type: TeamInfoConstants.Actions.FETCH_TEAM_INFO_FAILURE,
          payload: error.message,
        });
        throw error;
      });
  };
};
